import styled from 'styled-components';

const StyledListItem = styled.li.attrs({ className: 'dropdown__item' })``;

export default StyledListItem;
